module.exports = __webpack_public_path__ + "img/guardians.8d4776ff.svg";